import { EstimateMetaType, EstimateStatusType } from "@/types/db/estimates";

export type EstimateForm = {
  estimate_number?: string;
  client_id: string;
  project_id: string;
  status: EstimateStatusType;
  meta_data?: EstimateMetaType;
};

export type EstimatePayload = {
  estimate: EstimateForm;
};
